export const ProfilePhotoCompressConfig = {
  compressionRatio: 0.5, // Adjust this value to change the compression quality
  compressionFormat: 'image/jpeg',
  acceptableRatios: [1, 4 / 3, 16 / 9, 3 / 2],
};
